import { getCookie, removeCookie } from './Cookies';
import { toast } from 'react-toastify';

export const getUserLoginToken = () => {
    // always fetch the latest value from the cookie:
    const userData = getUser();
    const token = userData?.token;
    return token;
};

export const CookieNames = Object.freeze({
    userInfo: 'user-info',
    persistenceKey: 'persistence-key',
    userId: 'userId',
    userName: 'userName',
    firstName: 'firstName',
    lastName: 'lastName',
    emailAddress: 'emailAddress',
    customerId: 'customerId',
    userRole: 'userRole',
    isAdmin: 'isAdmin',
});

/** Get User info object from cookies
 * @returns {object} - User object
 */
export const getUser = () => getCookie('user-info');
export const getToken = () => getCookie('persistence-key');
export const getUserId = () => getCookie('userId');
export const getLoginName = () => getCookie('userName');
export const getUserName = () => getCookie('userName');
export const getFirstName = () => getCookie('firstName');
export const getLastName = () => getCookie('lastName');
export const getUserEmailAddress = () => getCookie('emailAddress');
export const getCustomerId = () => getCookie('customerId');
export const getUserRole = () => getCookie('userRole');
/** True if the isAdmin cookie is set. universal-cookie auto-JSON-parses cookie values, so a
 * cookie stored as the string "true" comes back as the boolean `true`, not the string --
 * normalize here so callers don't have to know that. */
export const getIsAdminStatus = () => {
    const v = getCookie('isAdmin');
    return v === true || v === 'true';
};

export const getUserInformation = () => {
    // return user;
    return getUser();
};

export const removeAllCookies = () => {
    removeCookie('user-info');
    removeCookie('persistence-key');
    removeCookie('userId');
    removeCookie('customerId');
    removeCookie('userName');
    removeCookie('firstName');
    removeCookie('lastName');
    removeCookie('emailAddress');
    removeCookie('userRole');
    removeCookie('isAdmin');
};

/** Comprehensive logout function that handles admin logout with page reload
 * @param {boolean} isAdmin - Whether the user is an admin
 * @param {Function} showMessage - Function to show logout message
 * @param {Function} navigate - Navigation function
 */
export const logoutUser = (isAdmin = false, showMessage = null, navigate = null) => {
    // Dismiss all loading toasts (including "Logging in..." if present)
    toast.dismiss();
    
    // Remove all authentication cookies
    removeAllCookies();
    
    // Show logout message if provided
    if(showMessage){
        showMessage('Logged out', 'bottom-center', 2500);
    }
    
    // Handle admin logout with page reload
    if(isAdmin){
        console.log('Admin user logged out, reloading page...');
        setTimeout(() => {
            window.location.reload();
        }, 1000); // Small delay to show logout message
    }else if(navigate){
        // For non-admin users, navigate to home
        navigate('/');
    }
};

/** True when a non-empty session token cookie exists (client-readable). Prefer `useAuth()` for UI gating. */
export const isUserLoggedIn = () => {
    const t = getCookie('persistence-key');
    return t != null && String(t).trim() !== '';
};
